/* eslint-disable @typescript-eslint/no-explicit-any */
import { strings } from 'resources/i18n';

export const formatI18n = (str: string) => (variables: any) => strings.formatString(str, variables).toString();
